export const RESTRICT_IMAGES = {
  PACKAGE: "https://awsimgsrc.dmm.com/dig/dmmtv/etc/restriction/package.jpg",
  KEY_LOGO: "https://awsimgsrc.dmm.com/dig/dmmtv/etc/restriction/keylogo.jpg",
  LOGO: "https://awsimgsrc.dmm.com/dig/dmmtv/etc/restriction/logo.jpg",
} as const;
